import { lazy, PropsWithChildren, Suspense, useEffect } from 'react';
import useStudioGroup from './hooks/useStudioGroup';
const IanuaStyleImport = lazy(() => import('./IanuaStyleImports'));
const ThemePrima = lazy(() => import('./ThemePrima'));
const ThemeSecunda = lazy(() => import('./ThemeSecunda'));

export default function AppStyles({ children }: PropsWithChildren = {}) {
  const studioGroup = useStudioGroup();

  useEffect(() => {
    window.loadingScreen?.finish();
  }, []);

  if (studioGroup === 'BAO') {
    return (
      <Suspense fallback={null}>
        <ThemePrima>
          <IanuaStyleImport>{children}</IanuaStyleImport>
        </ThemePrima>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={null}>
      <ThemeSecunda>
        <IanuaStyleImport>{children}</IanuaStyleImport>
      </ThemeSecunda>
    </Suspense>
  );
}
